var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.65,
    height: 17.313,
    viewBox: "0 0 16.65 17.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_date_1272092",
    transform: "translate(-210.675 -29.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M8.27,21.563H20.38a2.27,2.27,0,0,0,2.27-2.27V8.318a2.27,2.27,0,0,0-2.27-2.27H18.866V5.007a.757.757,0,1,0-1.514,0V6.047H11.3V5.007a.757.757,0,1,0-1.514,0V6.047H8.27A2.27,2.27,0,0,0,6,8.318V19.292A2.27,2.27,0,0,0,8.27,21.563ZM20.38,20.049H8.27a.757.757,0,0,1-.757-.757V13.048H21.137v6.244A.757.757,0,0,1,20.38,20.049ZM8.27,7.561H9.784v.851a.757.757,0,1,0,1.514,0V7.561h6.055v.851a.757.757,0,0,0,1.514,0V7.561H20.38a.757.757,0,0,1,.757.757v3.217H7.514V8.318A.757.757,0,0,1,8.27,7.561Z",
    transform: "translate(204.675 25.094)",
    fill: "#07b4e8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c8caa0c8aa873db90c91314f43c746eb.svg";
export { ForwardRef as ReactComponent };